/** Compiler contract: NWI grouping id + SHA-256 of the complete native geometry. */
export function nwiGroupFromSourceFeatureId(sourceId: string): string | undefined {
  return /^(.+):[a-f0-9]{64}$/i.exec(sourceId)?.[1];
}

/** Distinct statewide versions of one group may overlap; source ACRES cannot be summed safely. */
export function hasAmbiguousNwiSourceGroups(sourceIds: Iterable<string>): boolean {
  const seen = new Map<string,string>();
  for (const sourceId of sourceIds) {
    const group = nwiGroupFromSourceFeatureId(sourceId);
    if (!group) continue;
    const prior = seen.get(group);
    if (prior && prior !== sourceId) return true;
    seen.set(group,sourceId);
  }
  return false;
}
